import type {RequestMiddleware} from 'graphql-request';
import {GraphQLClient} from 'graphql-request';

import {getJWT} from './authService';

const graphqlEndpoint = window.AWS_GRAPHQL_URL || '';
const requestMiddleware: RequestMiddleware = async request => {
  return {
    ...request,
    headers: {
      ...request.headers,
      Authorization: (await getJWT())?.toString() || '',
      contentType: 'application/json',
    },
  };
};

const graphqlClient = new GraphQLClient(graphqlEndpoint, {
  requestMiddleware,
});

export {graphqlClient};
